


















/* ----------------------------------------
    Mixins
---------------------------------------- */

import { Component, Prop, Mixins, Emit, Watch, ProvideReactive, Vue } from 'vue-property-decorator';
import { DropPositionMixin } from './../mixins';
import { FormMixin, SlotsMixin } from '../../mixins';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            active: false,
            proxyPosition: null,
            dropClass: 'form-select__target',
            items: []
        }
    },

    mixins: [
        SlotsMixin,
        FormMixin,
    ],

    created() {
        this.proxyPosition = this.position;
        this.selected = this.model;
        this.multi = Array.isArray(this.model);
        this.mobile = false;

        this.$nextTick(() => {
            this.updateOptions()
        })
    },

    activated() {
        this.$nextTick(() => {
            this.updateOptions()
        })
    },

    mounted() {
        this.rootListener();

        this.$nextTick(() => {
            this.updateOptions()
        })
    },

    computed: {
        cClass() {
            let classes = ['form-select'];

            if (this.error)
                classes.push('has-error');

            if (!this.value)
                classes.push('has-novalue');

            if (this.value)
                classes.push('has-value');

            if (this.active)
                classes.push('is-active');

            return classes.join(' ');
        },

        cTargetClass() {
            const classes = ['form-select__target',  `form-select__target--${ this.proxyPosition }`];

            return classes.join(' ');
        }
    },

    methods: {
        getOptions() {
            return (this.$slots.default || [])
                .map(vnode => vnode.componentInstance)
                .filter(option => option && (option._isFormOption || option._isFormOptGroup))
        },

        updateOptions() {
            this.items = this.getOptions();

            this.items.forEach(item => {
                item.$on('select', (option) => {
                    const key = option.$vnode.key;

                    if (this.multi) {
                        const newModel = [...this.model];

                        if (this.model.indexOf(key) > -1)
                            newModel.splice(this.model.indexOf(key), 1)
                        else
                            newModel.push(key)

                        this.modelProxy = newModel;
                    } else {
                        this.modelProxy = key;
                        this.active = false;
                    }

                    this.onInput();
                    this.selected = this.modelProxy;
                })
            });
        },

        rootListener() {
            this.$root.$on('root::select::toggle', (event, uid) => {
                if (this._uid === uid) return
                this.active = false;
            });

            this.$root.$on('root::select::close', (event) => {
                this.active = false;
            });

            this.$root.$on('root::click', (event) => {
                this.active = false;
            });
        },
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class FormSelect extends Vue {
    @Prop({ default: 'left' }) position!: string;
    @Prop() options!: any;
    @Prop() value!: string;

    @ProvideReactive('selected') selected = null;

    @Emit()
    toggle(event) {
        this.active = !this.active;
        this.$root.$emit(`root::select::toggle`, event, this._uid);
        return this.active;
    }

    @Watch('active')
    onActiveChange(val: boolean) {
        this.$nextTick(() => {
            this.updateOptions()
        })
    }

    @Watch('$route')
    onRouteChange() {
        this.active = false;
    }

    @Watch('model')
    onModelChange() {
        this.selected = this.model;
    }
}

